import * as z from 'zod';

export const tcConditionQueryLinkerSchema = z.object({
  id: z.number(),
  title: z.string(),
});

export type TcConditionQueryLinkerSchema = z.infer<typeof tcConditionQueryLinkerSchema>;
